import { AbstractControl, FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { fileType } from '../helpers/validators/file-type.validator';
import { fileSize } from '../helpers/file-size.validator';
import { EnumAux } from '../helpers/enum-aux.helper';
import { Expert } from './expert.schema';
import { Delivery } from './delivery.schema';

export enum RefundRequestStatus {
    created = "created",
    approved = "approved",
    paid = "paid",
}

export enum ExpertReceiptStatus {
    open = "open",
    approved = "approved",
    paid = "paid",
}

export class RefundRequestStatusAux extends EnumAux {

    static active = ["created", "approved"];
    static inactive = ["paid"];
    static mixed = ["created", "paid", "approved"];

    static aux = {
        created: { css: "red", ln: { it: "creata" } },
        approved: { css: "yellow", ln: { it: "approvata" } },
        paid: { css: "green", ln: { it: "pagata" } },
    }
}

export class ExpertReceiptStatusAux extends EnumAux {

    static active = ["open", "approved"];
    static inactive = ["paid"];
    static mixed = ["open", "paid", "approved"];

    static aux = {
        open: { css: "red", ln: { it: "open" } },
        approved: { css: "yellow", ln: { it: "approvata" } },
        paid: { css: "green", ln: { it: "pagata" } },
    }
}
export class RefundRequest {
    public static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            plusValue: new FormControl(0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
            requestText: new FormControl('', Validators.required),
            receipt: new FormControl(
                undefined,
                [
                    Validators.required,
                    fileType(['png', 'jpg', 'gif', 'jpeg']),
                    fileSize(2)   // For 2MB
                ]
            ),
            expert: new FormGroup(
                { id: new FormControl('') }
            ),
            delivery: new FormGroup(
                { id: new FormControl('') }
            ),
        };
        return validator;
    }

    public static readonly validationMessages = {
        'requestText': [
            { type: 'required', message: 'Obbligatorio' }
        ],
        'plusValue': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'pattern', message: 'Deve essere un numero valido' }
        ],
        'receipt': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'fileType', message: 'Formati accettati: png, jpg, gif, jpeg' },
            { type: 'fileSize', message: 'Il file non deve superare 2MB' },
        ],
        'expert': {
            'id': [
                { type: 'required', message: 'Obbligatorio' }
            ]
        },
    };

    constructor(
        public id?: number,
        public requestText?: string,
        public plusValue?: number,
        public requestStatus?: string,
        public receipt?: string,
        public expert?: Expert,
        public delivery?: Delivery,
        public createdAt?: Date
    ) { }
}